import React from 'react';
import '../styles/Intro.css';
import introImage from '../Assets/Images/akij-uddin.png'; // founder photo

function Intro() {
  return (
    <section className="intro-section" id="about">
      <div className="intro-container">
        {/* Left: Intro text */}
        <div className="intro-text">
          <h2>Welcome To Akij Foundation <br /> Vocational School (AFVS)</h2>
          <p>
            আকিজ ফাউন্ডেশন ভোকেশনাল স্কুল বাংলাদেশের স্বনামধন্য আকিজ ইনসাফ-এর অর্থায়নে পরিচালিত একটি অত্যাধুনিক ও মানসম্মত
            কারিগরি শিক্ষা প্রতিষ্ঠান। আকিজ গ্রুপের প্রতিষ্ঠাতা মাননীয় শেখ আকিজ উদ্দিনের স্বপ্ন পূরনের লক্ষ্যে তার সন্তান শেখ জামিল উদ্দিন
            এই প্রতিষ্ঠানটি স্থাপনের কাজ শুরু করেন। তাই এই প্রতিষ্ঠানের নামকরণ করা হয়েছে আকিজ ফাউন্ডেশন ভোকেশনাল স্কুল।
          </p>
          <p>
            বাংলাদেশ কারিগরি শিক্ষা বোর্ড আকিজ ফাউন্ডেশন ভোকেশনাল স্কুলকে ২০২৩ সালে মাধ্যমিক স্কুল স্থাপনের অনুমতি প্রদান করে।
            বর্তমানে এই শিক্ষা প্রতিষ্ঠানে প্রি-ভোকেশনাল (ষষ্ঠ-অষ্টম শ্রেণি) শাখাসহ ভোকেশনাল (নবম-দশম শ্রেণি) এর বিজ্ঞান বিভাগের একাধিক
            শাখায় (যেমন:- কম্পিউটার, ইলেকট্রিক্যাল, মেকানিক্যাল, অটোমোবাইল ইত্যাদি) শিক্ষা প্রদান করা হয়।
          </p>
          <p>
            এই শিক্ষা প্রতিষ্ঠানটি একই সাথে বাংলাদেশ জাতীয় দক্ষ উন্নয়ন কর্তৃপক্ষ স্বীকৃত একটি কারিগরি প্রশিক্ষণ কেন্দ্র, যা ২০২৪ সালে অনুমোদিত হয়।
            বর্তমানে এখানে রেফ্রিজারেশন অ্যান্ড এয়ার কন্ডিশনিং, ইলেকট্রিক্যাল, কম্পিউটার, ড্রাইভিং ইত্যাদি বিষয়ে সফলতার সাথে প্রশিক্ষণ প্রদান করা হয়।
          </p>
          <p>
            আধুনিক প্রযুক্তিগত উন্নয়নের সাথে তাল মিলিয়ে অভিজ্ঞ জনবল কাঠামো গঠনের মাধ্যমে আর্ন্তজাতিক মান সম্মত শিক্ষা ও প্রশিক্ষণ প্রদান করে
            প্রযুক্তিকে আরও গতিশীল করা এবং দক্ষ জনসম্পদ তৈরি করে দেশ ও জাতির উন্নয়নে বলিষ্ঠ ভূমিকা রাখাই প্রতিষ্ঠানের মূল লক্ষ্য।
          </p>
        </div>

        {/* Right: Founder’s Message card */}
        <aside className="founder-card" aria-labelledby="founder-title">
          <img
            src={introImage}
            alt="Founder"
            className="founder-photo"
            loading="lazy"
          />

          <h3 id="founder-title" className="founder-title">
            Founder&apos;s Message
          </h3>

          <p className="founder-text">
            দেশের অর্থনৈতিক পরিবর্তন ঘটানোর ক্ষেত্রে কারিগরি শিক্ষার কোন বিকল্প নেই। এই শিক্ষা সর্বস্তরের মানুষের অর্জন করা প্রয়োজন।
            কারণ প্রযুক্তিগত শিক্ষা শিল্পায়নে ও মানুষের দৈনন্দিন জীবনে চলাচলের পথকে সহজ ও গতিশীল করতে সক্ষম। বিশেষ করে পিছিয়ে
            পড়া মানুষকে এগিয়ে নিতে কারিগরি শিক্ষার ভূমিকা অতুলনীয়। যা আমাদের দেশের প্রেক্ষাপটে অত্যন্ত গুরুত্বপূর্ণ।
          </p>
        </aside>
      </div>
    </section>
  );
}

export default Intro;
